"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var ensureArray = function ensureArray() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 0 || args[0] === undefined || args[0] === null) {
    return [];
  }

  if (args.length === 1) {
    return [].concat(args[0]);
  }

  return [].concat(args);
};

var _default = ensureArray;
exports["default"] = _default;